import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { ConfigurationTranslationController } from "@plansoft-configuration-renderer/localization";
import { ConfigurationPathSwitcher } from "../NavigationState/ConfigurationPathSwitcher";
import { ConfigurationObjectContext } from "../context/ConfigurationObjectContext";
import { ConfigurationPathContext } from "../context/ConfigurationPathContext";
import { RootObjectContext } from "../context/RootObjectContext";
import { useConfigurationRootState } from "../hooks/useConfigurationRootState";
import { useCsConfigurationApi } from "../hooks/useCsConfigurationApi";
import { getCurrentCfgObject, getRootCfgObject } from "../reducers/selectors";
import { ConfigurationFrameController } from "./ConfigurationFrameController";
// import { ConfigurationSelectorSpy } from "./ConfigurationSelectorSpy";
/**
 * Utility function that prevents the configuration from rendering if the there is no cfg object
 * - requires {@linkcode ConfigurationController}
 *
 * ⚠️ WARNING !!! Do not put this inside a suspense, see [react-redux](https://github.com/reduxjs/react-redux/issues/1977)
 * @category Controller
 * @param props
 */
export function ConfigurationRenderer(props) {
    const { children } = props;
    const ecsState = useConfigurationRootState();
    const { fetchConfigurationUnits, fetchCurrencies } = useCsConfigurationApi();
    const cfgObject = getCurrentCfgObject(ecsState);
    const rootObject = getRootCfgObject(ecsState);
    useEffect(() => {
        fetchConfigurationUnits();
    }, [fetchConfigurationUnits]);
    useEffect(() => {
        fetchCurrencies();
    }, [fetchCurrencies]);
    if (cfgObject == null) {
        return null;
    }
    if (rootObject == null) {
        return null;
    }
    return (_jsx(RootObjectContext.Provider, { value: rootObject, children: _jsx(ConfigurationPathContext.Provider, { value: cfgObject.path, children: _jsx(ConfigurationObjectContext.Provider, { value: cfgObject, children: _jsxs(ConfigurationTranslationController, { cfgObject: cfgObject, children: [_jsx(ConfigurationFrameController, {}), _jsx(ConfigurationPathSwitcher, {}), children] }) }) }) }));
}
//# sourceMappingURL=ConfigurationRenderer.js.map